<template>
  <div>
    <form class="needs-validation" @submit.prevent="formSubmit">
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Correo electrónico / Usuario" label-for="email">
            <b-form-input
                id="email" v-model="usuario.email" type="email"
                maxlength="150" name="email"
                :class="{ 'is-invalid': sending && $v.usuario.email.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.email.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.email.required">Correo electrónico es requerido</span>
              <span v-if="!$v.usuario.email.email">Formato incorrecto</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Nombre social" label-for="name">
            <b-form-input
                id="name" v-model="usuario.name" type="text"
                maxlength="50" name="name"
                :class="{ 'is-invalid': sending && $v.usuario.name.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.name.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.name.required">Nombre social es requerido</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Primer nombre" label-for="primernombre">
            <b-form-input
                id="primernombre" v-model="usuario.primernombre" type="text"
                maxlength="50" name="primernombre"
                :class="{ 'is-invalid': sending && $v.usuario.primernombre.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.primernombre.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.primernombre.required">Primer nombre es requerido</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Segundo nombre" label-for="segundonombre">
            <b-form-input
                id="segundonombre" v-model="usuario.segundonombre" type="text"
                maxlength="50" name="segundonombre"
                :class="{ 'is-invalid': sending && $v.usuario.segundonombre.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.segundonombre.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.segundonombre.required">Primer nombre es requerido</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Apellido paterno" label-for="apellidopaterno">
            <b-form-input
                id="apellidopaterno" v-model="usuario.apellidopaterno" type="text"
                maxlength="50" name="apellidopaterno"
                :class="{ 'is-invalid': sending && $v.usuario.apellidopaterno.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.apellidopaterno.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.apellidopaterno.required">Apellido paterno es requerido</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Apellido materno" label-for="apellidomaterno">
            <b-form-input
                id="apellidomaterno" v-model="usuario.apellidomaterno" type="text"
                maxlength="50" name="apellidomaterno"
                :class="{ 'is-invalid': sending && $v.usuario.apellidomaterno.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.apellidomaterno.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.apellidomaterno.required">Apellido materno es requerido</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Teléfono" label-for="telefono">
            <b-form-input
                id="telefono" v-model="usuario.telefono" type="text"
                maxlength="50" name="telefono"
                :class="{ 'is-invalid': sending && $v.usuario.telefono.$error }"></b-form-input>
            <div v-if="sending && $v.usuario.telefono.$error" class="invalid-feedback">
              <span v-if="!$v.usuario.telefono.required">RUT es requerido</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Contraseña" label-for="password">
            <b-form-input
                id="password" v-model="usuario.password" type="text"
                maxlength="50" name="password"
                :class="{ 'is-invalid': sending && $v.usuario.password.$error }"></b-form-input>
            <div style="font-size: 9px; color: red" v-if="usuario.id != null">
              Ingresar cuando quiera cambiarla
            </div>
          </b-form-group>
        </div>

      </div>
      <div class="row">
        <div class="col-md-5">
          <b-form-group label="Sucursal" label-for="idsucursal">
            <b-form-select id="idsucursal" v-model="usuario.idsucursal" name="idsucursal"
                           :options="sucursales"
                           value-field="value" text-field="text"></b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Rol" label-for="rol">
            <b-form-select id="rol" v-model="usuario.rol" name="rol"
                           :options="roles"
                           value-field="value" text-field="text"></b-form-select>
          </b-form-group>
          <div v-if="sending && $v.usuario.rol.$error" class="invalid-feedback">
            <span v-if="!$v.usuario.rol.required">Rol es requerido</span>
          </div>
        </div>
        <div class="col-md-3">
          <b-form-checkbox
              id="active"
              v-model="usuario.active"
              name="active"
              value="1"
              unchecked-value="0"
              style="margin-top: 36px;"
          >
            Usuario activo
          </b-form-checkbox>
        </div>

      </div>
      <div class="row">
        <div class="col-md-12">
        </div>
      </div>
      <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
      <button class="btn btn-primary" type="submit" :disabled="posting" v-if="usuario.id == null">Crear</button>
      <button class="btn btn-primary" type="submit" :disabled="posting" v-if="usuario.id != null">Actualizar</button>

    </form>
  </div>
</template>

<script>
import {email, maxLength, required} from "vuelidate/lib/validators";
import {usuariosService} from "@/helpers/servicios/configuracion/usuarios.service";
// import {generalService} from "@/helpers/servicios/configuracion/genera.service";

export default {
  name: "edicionUsuario",
  props: ["id", "disponibilidad"],
  data()  {
    return {
      usuario: {}, //roles: [], //sucursales: [],
      error: null,
      sending: false, posting: false,
      tiposusuario: [],
      oldIdSucursal: 0,
      oldRol: 0
    }
  },
  computed: {
    sucursales: function()  {
      let retorno = []
      this.disponibilidad.forEach(element => {
        if (!element.administrador || element.cupos > element.utilizados)  {
          retorno.push({ value: element.idsucursal, text: element.identificacion })
        }
      })
      if (this.usuario.id !== null && this.usuario.id !== 0)  {
        if (this.usuario.idsucursal === null) return []
        const encontrar = retorno.find(element => element.value === this.oldIdSucursal)
        if (encontrar === undefined || encontrar === null)  {
          const sucursal = this.disponibilidad.find(element => element.idsucursal == this.oldIdSucursal)
          if (sucursal !== undefined && sucursal !== null)  {
            retorno.push({ value: sucursal.idsucursal, text: sucursal.identificacion })
          }
        }
      }
      return retorno;
    },
    roles: function() {
      if (this.usuario.idsucursal === null) return []
      let retorno = []
      const sucursal = this.disponibilidad.find(element => element.idsucursal == this.usuario.idsucursal)
      if (sucursal === undefined || sucursal === null)  return []
      if (this.usuario.id === null || this.usuario.id === 0)  {
        if (!sucursal.administrador)  retorno.push({ value: 2, text: "Admin. Sucursal"})
        if (sucursal.cupos > sucursal.utilizados) {
          retorno.push({ value: 3, text: "Cajero"})
          retorno.push({ value: 4, text: "Estacionador"})
        }
      } else {
        if (this.usuario.rol === 2) {
          retorno.push({ value: 2, text: "Admin. Sucursal"})
          if (sucursal.cupos > sucursal.utilizados) {
            retorno.push({ value: 3, text: "Cajero"})
            retorno.push({ value: 4, text: "Estacionador"})
          }
        } else {
          if (!sucursal.administrador)  retorno.push({ value: 2, text: "Admin. Sucursal"})
          retorno.push({ value: 3, text: "Cajero"})
          retorno.push({ value: 4, text: "Estacionador"})
        }
      }
      return retorno
    }
  },
  watch: {
    id: function() {
    },
  },
  validations: {
    usuario: {
      name: { required, maxLength: maxLength(50)},
      primernombre: { required, maxLength: maxLength(50)},
      segundonombre: { maxLength: maxLength(50)},
      apellidopaterno: { required, maxLength: maxLength(50)},
      apellidomaterno: { maxLength: maxLength(50)},
      email: { required, email, maxLength: maxLength(200) },
      telefono: { maxLength: maxLength(20) },
      rol: { required },
      idsucursal: {},
      password: {},
      active: {}
    }
  },
  mounted() {
    this.obtenerUsuario();
  },
  methods:  {
    async obtenerUsuario()  {
      let id = this.id
      if (this.id == null)  id = 0
      usuariosService.editarUsuario(id).then((response) => {
        if (response.usuario == null) {
          this.usuario = this._usuarioEmpty()
        } else {
          this.usuario = response.usuario;
          this.oldIdSucursal = this.usuario.idsucursal
          this.oldRol = this.usuario.rol
        }
        // this.roles = response.roles
        // this.sucursales = response.sucursales
      })
    },
    formSubmit()    {
      this.sending = true;
      this.$v.$touch();
      if (!this.$v.$invalid)  {
        if (this.usuario.id == null && this.usuario.password == null) {
          this._error("Debe ingresar una contraseña para el nuevo usuario");
          return false;
        }
        this.guardarUsuario();
      }
    },
    guardarUsuario()  {
      this.posting = true;
      usuariosService.guardarUsuario(this.usuario).then((response) => {
        this.posting = false
        if (response.resultado == "ok") {
          this.$emit("updateUsuarios", { update: true} );
        } else {
          this._error(response.mensaje);
        }
      }).catch((error) => {
        this.posting = false
        if (error.status == 422)  {
          this._error("Datos incompletos o con errores, por favor revíselos");
        } else {
          this._error(error.mensaje);
        }
      })
    },
    _usuarioEmpty() {
      return {  id: null,
                name: null, primernombre: null, segundonombre: null, apellidopaterno: null, apellidomaterno: null,
                email: null, telefono: null, rol: null, idsucursal: null, active: 1 }
    },
    _error(mensaje)   {
      this.error = mensaje;
      setTimeout(() => { this.error = null; }, 5000);
    }
  }
}
</script>

<style scoped>

</style>
